import React, { useCallback } from "react";
import { Grid } from "semantic-ui-react";
import RoutingModal from "@commonComponents/routingModal";
import { FormTitle } from "@commonComponents/FormTitle";
import { useSelector } from "react-redux";
import DisplaySelectedCountryList from "./displaySelectedCountryList";
import { useCurrentShipmentType } from "@hooks/useCurrentShipmentType";

const RoutingCountry = ({ className, translate, addItem, onSelect, deleteItem, limit=99, countryList, tableName = "routingCountriesList", ...rest }) => {
  const { isDisabled, countryCode } = useCurrentShipmentType();
  const selectedCountryList = useSelector((state) => state.transportReducer[tableName]);
  const addCountry=useCallback(()=>addItem(tableName,{countryCode:countryCode}),[addItem])
  const deleteSelectedCountry=useCallback((id)=>deleteItem(id,tableName),[deleteItem])
  const onDropDownChange=useCallback((id,params)=>{
    params.id=id
    onSelect(id,tableName,params)
  },[tableName,onSelect])

  return (
    <div className={`${className} col formContainer`}>
      <Grid.Row>
        <Grid.Column className='row' id='routingCountryParentElement'>
          <FormTitle
            containerStyle={{ marginLeft: '4px', width: '100%' }}
            className='formTitle'
            textAlign='start'
            title='ITINERARY_COUNTRY'
          />
          <DisplaySelectedCountryList
            countryList={countryList}
            dataSource={selectedCountryList}
            isFormDisabled={isDisabled}
            deleteItem={deleteSelectedCountry}
          />
          <RoutingModal
            headerName='ITINERARIES'
            valueKey='countryCode'
            limit={limit}
            isFormDisabled={isDisabled}
            AddItem={addCountry}
            updateData={onDropDownChange}
            deleteData={deleteSelectedCountry}
            dataList={selectedCountryList}
            dataSource={countryList}
            fieldType='dropdown'
            {...rest}
          />
        </Grid.Column>
      </Grid.Row>
    </div>
  )
}

RoutingCountry.defaultProps = {
  translate:(value)=>value
}
export default React.memo(RoutingCountry)
